var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location-d" },
    [
      _c(
        "button",
        {
          staticClass: "location-d__link",
          class: _vm.cityName.length > 15 ? "location-d__link-truncate" : "",
          attrs: { type: "button" },
          on: { click: _vm.showLocationPopup }
        },
        [
          _c("icon", {
            staticClass: "location-d__link-icon",
            attrs: { name: "Location_16", width: "16", height: "16" }
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "location-d__link-text js-delivery-location" },
            [_vm._v("\n      " + _vm._s(_vm.cityName) + "\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLocationPopup,
              expression: "isLocationPopup"
            }
          ],
          staticClass: "location-d__popup"
        },
        [
          _c(
            "button",
            {
              staticClass: "location-d__popup-close",
              on: { click: _vm.hideLocationPopup }
            },
            [
              _c("icon", {
                staticClass: "location-d__close-icon",
                attrs: { name: "close-extra", width: "12", height: "12" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "location-d__popup-title" }, [
            _vm._v("\n      Ваш город —\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "location-d__popup-city js-delivery-location" },
            [_vm._v("\n      " + _vm._s(_vm.cityName) + "?\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "location-d__popup-buttons" }, [
            _c(
              "div",
              { staticClass: "location-d__popup-btn" },
              [
                _c(
                  "button-control",
                  {
                    staticClass: "_gary _location",
                    attrs: { size: "small" },
                    on: { click: _vm.showCityModal }
                  },
                  [_vm._v("\n          Выбрать другой\n        ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "location-d__popup-btn" },
              [
                _c(
                  "button-control",
                  {
                    staticClass: "_location js-geo-accept",
                    attrs: {
                      size: "small",
                      "data-geo-accept-cookie-name": _vm.cookieName,
                      "data-geo-accept-cookie-true-value": _vm.cookieTrueValue,
                      "data-geo-accept-cookie-http-host": _vm.cookieHttpHost,
                      "data-geo-accept-cookie-expires-days":
                        _vm.cookieExpiresDays
                    },
                    on: { click: _vm.applyLocation }
                  },
                  [_vm._v("\n          Да, всё верно\n        ")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("city-modal", {
        attrs: {
          "is-world-delivery": true,
          city: { name: _vm.cityName },
          name: "city-modal-header"
        },
        on: { selected: _vm.modalSelectedHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }